import { LensHit } from "Backend";
import { HitTableContext } from "contexts/HitTableContext";
import { DocumentIntake, FormField } from "generated/graphql";
import { FC, useState } from "react";
import { StateHandle } from "StateHandle";
import { LensHitFilterState } from "../LensHitFilterState";
import { UseFormCard } from "../useFormCard";
import HitTable from "./HitTable";

interface HitTableWrapperProps {
  lensId: number;
  caseId: number;
  intake: DocumentIntake | undefined;
  overrideHitHandle: StateHandle<LensHit | undefined>;
  formField: FormField;
  lensHitFilterState: LensHitFilterState;
  selectedCategoryRuleId: string | undefined;
  setPageNum: (page: number) => void;
}

const HitTableWrapper: FC<HitTableWrapperProps> = ({
  selectedCategoryRuleId,
  setPageNum,
  lensHitFilterState,
  overrideHitHandle,
  lensId,
  caseId,
  intake,
  formField,
}) => {
  const [formCardMap, setFormCardMap] = useState<Map<number, UseFormCard>>(new Map());
  const [hitInEdit, setHitInEdit] = useState<number | undefined>(undefined);
  const [hits, setHits] = useState<LensHit[]>([]);
  const [hitsFullCount, setHitsFullCount] = useState<number>(0);
  const [checkedHits, setCheckedHits] = useState<LensHit[]>([]);

  return (
    <HitTableContext.Provider
      value={{
        lensId,
        caseId,
        intake,
        formField,
        formCardMap,
        setFormCardMap,
        hitInEdit,
        setHitInEdit,
        hits,
        setHits,
        hitsFullCount,
        setHitsFullCount,
        checkedHits,
        setCheckedHits,
      }}>
      <HitTable
        overrideHitHandle={overrideHitHandle}
        lensHitFilterState={lensHitFilterState}
        selectedCategoryRuleId={selectedCategoryRuleId}
        setPageNum={setPageNum}
      />
    </HitTableContext.Provider>
  );
};

export default HitTableWrapper;
